import React from "react";
import styled from "styled-components";
import { space, layout } from "styled-system";

import StyledIcon from "../Interfaces/StyledIcon";

const StyledContainer = styled.div<StyledIcon>`
  display: inline-block;
  ${space}
  ${layout}
`;

const DownloadSVG: React.FunctionComponent<StyledIcon> = ({
  fill = "black",
  ...props
}) => {
  return (
    <StyledContainer {...props} color="primary-light-blue">
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill={fill}
          d="M7.59375 0C7.10156 0 6.75 0.386719 6.75 0.84375V6.75H3.65625C3.02344 6.75 2.70703 7.52344 3.16406 7.98047L8.50781 13.3242C8.75391 13.5703 9.21094 13.5703 9.45703 13.3242L14.8008 7.98047C15.2578 7.52344 14.9414 6.75 14.3086 6.75H11.25V0.84375C11.25 0.386719 10.8633 0 10.4062 0H7.59375ZM18 13.2188C18 12.7617 17.6133 12.375 17.1562 12.375H11.9883L10.2656 14.0977C9.5625 14.8359 8.40234 14.8359 7.69922 14.0977L5.97656 12.375H0.84375C0.351562 12.375 0 12.7617 0 13.2188V17.1562C0 17.6484 0.351562 18 0.84375 18H17.1562C17.6133 18 18 17.6484 18 17.1562V13.2188ZM13.6406 16.3125C13.6406 16.6992 13.3242 17.0156 12.9375 17.0156C12.5508 17.0156 12.2344 16.6992 12.2344 16.3125C12.2344 15.9258 12.5508 15.6094 12.9375 15.6094C13.3242 15.6094 13.6406 15.9258 13.6406 16.3125ZM15.8906 16.3125C15.8906 16.6992 15.5742 17.0156 15.1875 17.0156C14.8008 17.0156 14.4844 16.6992 14.4844 16.3125C14.4844 15.9258 14.8008 15.6094 15.1875 15.6094C15.5742 15.6094 15.8906 15.9258 15.8906 16.3125Z"
        />
      </svg>
    </StyledContainer>
  );
};

export default DownloadSVG;
